import $ from 'jquery';

export default class ClickOutside {
  init(selector, callback) {
    $(document).one('mouseup', event => {
      const container = $(selector);
      if (!container.is(event.target) && container.has(event.target).length === 0) {
        setTimeout(() => {
          container.addClass('d-none');

          if (callback) {
            callback();
          }
        }, 10);
      } else {
        this.init(selector, callback);
      }
    });
  }
}
